<div class="w-full min-w-fit">
  <p-card>
    @if (loadFailed()) {
      <div data-testid="view-ta-load-error" class="flex flex-col items-center justify-center gap-3 w-full py-16">
        <i class="fa-light fa-exclamation-circle text-red-700 text-3xl"></i>
        <div class="text-surface-800 text-base font-medium font-['Inter'] leading-6">This TA could not be loaded</div>
        <div class="text-slate-500 text-sm font-normal font-['Inter'] leading-6">{{loadErrorMessage()}}</div>
      </div>
    } @else if (!taLoaded()) {
      <div data-testid="view-ta-loading" class="flex flex-col items-center justify-center gap-4 w-full py-16">
        <taspinner size="lg"></taspinner>
        <div class="text-slate-500 text-sm font-normal font-['Inter'] leading-6">Loading TA...</div>
      </div>
    } @else {
      <div class="flex flex-col gap-4 w-full h-full p-0 min-w-fit">
        @for (step of store.createTaSteps(); track step; let ii = $index) {
          @if (step.code !== CreateTaStepType.REVIEW) {
            <div class="w-full flex gap-2 p-0">
              <div class="flex flex-col w-64 bg-surface-0 p-4 gap-3 rounded-l-xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
                <div class="self-stretch justify-start text-surface-800 text-base font-normal font-['Inter'] leading-6">Stage {{ii+1}}</div>
                <div class="self-stretch justify-start text-surface-800 text-xl font-medium font-['Inter'] leading-6">{{step.title}}</div>
              </div>
              <div class="flex-1 flex justify-between bg-surface-0 p-6 gap-6 rounded-r-xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
                <div class="flex-1">
                  <create-ta-step-container [currentStep]="step" [isReadOnly]="true" [(travellerId)]="itineraryTravellerId"></create-ta-step-container>
                </div>
                @if (canEdit(step)) {
                  <p-button class="edit" size="small" [attr.data-testid]="'view-ta-edit-' + step.code" (onClick)="openEditModal(step)">
                    <span>Edit</span>
                    <i class="fa-light fa-pencil"></i>
                  </p-button>
                }
              </div>
            </div>
          }
        }
      </div>
    }
  </p-card>
</div>
